import { cn } from "../../lib/utils";

const variants = {
  default: "bg-brand-purple text-white hover:bg-brand-purple-dark shadow-sm",
  outline:
    "border border-zinc-200 bg-white text-brand-ink hover:bg-zinc-50 shadow-sm",
  ghost: "bg-transparent text-brand-ink hover:bg-zinc-50",
};

export function Button({
  className,
  variant = "default",
  type = "button",
  children,
  ...props
}) {
  return (
    <button
      type={type}
      className={cn(
        "inline-flex items-center justify-center gap-2 rounded-md text-sm font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-purple/40 disabled:pointer-events-none disabled:opacity-50",
        variants[variant] || variants.default,
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
}
